module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/carousel-4-450.1a8f44ddd4143ca0.jpg"+" 450w"+","+"https://static.sniffspot.com/packs/img/carousel-4-600.59bca535f844fed4.jpg"+" 600w",
        images: [{path: "https://static.sniffspot.com/packs/img/carousel-4-450.1a8f44ddd4143ca0.jpg",width: 450,height: 263},{path: "https://static.sniffspot.com/packs/img/carousel-4-600.59bca535f844fed4.jpg",width: 600,height: 350}],
        src: "https://static.sniffspot.com/packs/img/carousel-4-600.59bca535f844fed4.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/carousel-4-600.59bca535f844fed4.jpg"},
        
        width: 600,
        height: 350
      }